module.exports = __webpack_public_path__ + "img/display_bg.4fd606b3.png";